import { SignOutLogo } from "./Icons/CheckOutLogo";
import PopUp from "./PopUp/PopUp";
import { FC } from "react";


interface SessionExpirationPopup {
    session: boolean;
    message: string;
    title: string;
    buttonTxt: string;
    handleLogout: () => void

}

const SessionExpirationPopup: FC<SessionExpirationPopup> = ({ session, message, title, buttonTxt, handleLogout }) => {

    const renderBody = () => {
        return <div>
            {message} </div>
    };
    return (
        <>
            {session && <div className="signoutPopup">
                <PopUp
                    isOpen={true}
                    onClose={() => console.log("SessionExpired")}
                    header={title}
                    body={() => renderBody()}
                    closeButton={false}
                    actionButtons={
                        <div className="di-fl">  <button className="button-primary-light" onClick={() => { /* window.location.assign('/login');  */handleLogout() }} ><SignOutLogo />{buttonTxt}</button>
                        </div>
                    }
                />
            </div>}
        </>
    )
}

export default SessionExpirationPopup;